<template>
    <div id="fundamentals" :style="{ height: isSwiperActive ? totalSlides * 100 + 'vh' : 'auto' }">
        <div class="container-sticky" ref="containerSticky" @scroll.passive="handleWindowScroll" v-if="isSwiperActive">
            <div class="swiper-wrapper-container" ref="wrapperContainer">
                <swiper-container direction="vertical" slides-per-view="1" mousewheel="false" :space-between="spaceBetween" :centered-slides="true" :pagination="false" ref="swiperFundamentals">
                    <swiper-slide style="background: #1e1e3b">
                        <div class="slide-content" ref="slideContent">
                            <div>
                                <transition name="fade-slide" mode="out-in">
                                    <div v-html="$t('message.page_agency.intro')" class="intro" v-if="show"></div>
                                </transition>
                            </div>
                        </div>

                        <div class="scrolldown"></div>
                    </swiper-slide>

                    <swiper-slide v-for="(f, idx) in fundamentals" :key="idx" :style="`background: ${f.color};`">
                        <div class="slide-content" ref="slideContent">
                            <div>
                                <div>
                                    <transition name="fade-img" mode="out-in">
                                        <img :src="require('@/assets/img/' + f.img)" alt="" v-if="show" />
                                    </transition>
                                </div>
                                <div>
                                    <transition name="fade-slide" mode="out-in">
                                        <h1 v-if="show">{{ f.title }}</h1>
                                    </transition>
                                    <transition name="fade-slide-delayed" mode="out-in">
                                        <div v-html="f.desc" class="desc" v-if="show"></div>
                                    </transition>
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper-container>

                <!-- Pagination -->
                <div class="custom-pagination">
                    <button class="arrow up" @click="prevSlide" :disabled="indexBreakpoint === 0"><FontAwesomeIcon icon="chevron-up" /></button>

                    <ul class="titles-list">
                        <li v-for="(f, idx) in fundamentals" :key="idx" :class="{ active: idx + 1 === indexBreakpoint }" @click="goToSlide(idx + 1)">
                            <span>{{ f.title }}</span>
                            <span v-if="idx + 1 === indexBreakpoint" class="dot"></span>
                        </li>
                    </ul>

                    <button class="arrow down" @click="nextSlide" :disabled="indexBreakpoint === totalSlides - 1"><FontAwesomeIcon icon="chevron-down" /></button>
                </div>
            </div>
        </div>

        <div class="mobile-container" v-else>
            <div class="slide-content">
                <div>
                    <div v-html="$t('message.page_agency.intro')" class="intro"></div>
                </div>
            </div>
            <div v-for="(f, idx) in fundamentals" :key="idx" class="slide-content">
                <div>
                    <div>
                        <img :src="require('@/assets/img/' + f.img)" alt="" />
                    </div>
                    <div>
                        <h1>{{ f.title }}</h1>
                        <div v-html="f.desc" class="desc"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { register } from "swiper/element/bundle";
register();

import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faChevronUp, faChevronDown);

import "swiper/css";
import "swiper/css/effect-fade";

export default {
    name: "Fundamentals",
    data() {
        return {
            local: "fr",
            spaceBetween: 0,
            totalSlides: 0,
            indexBreakpoint: 0,
            isSwiperActive: true,
            bgSwipper: true,
            show: false,
        };
    },
    components: {
        FontAwesomeIcon,
    },
    computed: {
        fundamentals() {
            return this.$store.state.app.fundamentals[this.local];
        },
    },
    watch: {
        "$i18n.locale": function (locale) {
            this.local = locale;
        },
    },
    mounted() {
        this.totalSlides = this.fundamentals.length + 1;
        this.checkScreenSize();

        window.matchMedia("(max-width: 768px)").addEventListener("change", this.checkScreenSize);
        window.addEventListener("scroll", this.handleWindowScroll, { passive: true });

        this.show = true;
    },
    beforeUnmount() {
        window.removeEventListener("scroll", this.handleWindowScroll);
        window.matchMedia("(max-width: 768px)").removeEventListener("change", this.checkScreenSize);
    },
    methods: {
        checkScreenSize() {
            const isSmall = window.matchMedia("(max-width: 768px)").matches;
            this.isSwiperActive = !isSmall;
        },
        goToSlide(idx) {
            const swiper = this.$refs.swiperFundamentals?.swiper;
            const slidesContent = this.$refs.slideContent || [];
            const wrapper = this.$refs.swiperFundamentals;

            if (!swiper || !wrapper || !slidesContent.length) return;

            const directionUp = idx > this.indexBreakpoint;
            const translateYValue = directionUp ? "-60px" : "60px";

            wrapper.style.transition = "transform 0.3s ease-out";
            wrapper.style.transform = `translateY(${translateYValue})`;

            setTimeout(() => {
                this.show = false;

                setTimeout(() => {
                    wrapper.style.transform = "translateY(0)";
                    swiper.slideTo(idx, 0);

                    const divFundamentals = document.getElementById("fundamentals");
                    if (divFundamentals) {
                        const slideHeight = divFundamentals.offsetHeight / this.totalSlides;
                        const scrollTarget = divFundamentals.offsetTop + idx * slideHeight - slideHeight / 2.1;

                        this.scrollToWithDuration(scrollTarget, 1000);
                    }

                    setTimeout(() => {
                        // Mise à jour de l'index
                        this.indexBreakpoint = idx;
                        this.show = true;
                    }, 1000);
                }, 400);
            }, 200);
        },
        prevSlide() {
            if (this.indexBreakpoint > 0) {
                this.goToSlide(this.indexBreakpoint - 1);
            }
        },
        nextSlide() {
            if (this.indexBreakpoint < this.totalSlides - 1) {
                this.goToSlide(this.indexBreakpoint + 1);
            }
        },
        handleWindowScroll() {
            if (!this.isSwiperActive) return;

            const swiper = this.$refs.swiperFundamentals.swiper;
            const scrollY = window.scrollY || window.pageYOffset;
            const divFundamentals = document.getElementById("fundamentals");

            const offsetTop = divFundamentals.offsetTop;
            const height = divFundamentals.offsetHeight;

            const slideHeight = height / this.totalSlides;

            // Calcule l'index du slide actif en fonction du scroll
            let newIndex = Math.min(this.totalSlides - 1, Math.floor((scrollY - offsetTop + slideHeight / 2) / slideHeight));

            if (newIndex !== this.indexBreakpoint) {
                this.indexBreakpoint = newIndex;
                swiper.slideTo(newIndex);
            }
        },
        scrollToWithDuration(targetY, duration = 800) {
            const startY = window.scrollY || window.pageYOffset;
            const distance = targetY - startY;
            const startTime = performance.now();

            function easeInOut(t) {
                return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            }

            function step(currentTime) {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const eased = easeInOut(progress);

                window.scrollTo(0, startY + distance * eased);

                if (elapsed < duration) {
                    requestAnimationFrame(step);
                }
            }

            requestAnimationFrame(step);
        },
    },
};
</script>

<style lang="scss">
.slide-content {
    .intro {
        .span_1 {
            color: #dcc4ff;
            font-weight: 600;
        }

        .span_2 {
            color: #ff000e;
            font-weight: 600;
        }
    }
}
</style>
<style scoped lang="scss">
#fundamentals {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    background: #1e1e3b;
}

.container-sticky {
    width: 100%;
    height: 100vh;
    position: sticky;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.swiper-wrapper-container {
    height: 100vh;
    width: 100%;
    position: relative;
    position: relative;
    display: flex;
    flex-flow: row;
}

swiper-container {
    height: 100%;
    width: 100%;
}

swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    padding: 0;
    box-sizing: border-box;
    padding-right: 16rem;
}

.slide-content {
    text-align: right;
    max-width: 1200px;
    padding: 0 2rem;
    box-sizing: border-box;

    > div {
        display: flex;
        flex-flow: row nowrap;
        width: 100%;
        align-items: center;

        > div {
            flex: 1;
        }
    }

    h1 {
        font-size: 3.4rem;
        margin: 0 0 1rem;
        color: #56a7db;
        font-weight: 600;
        font-style: italic;
        padding-left: 2rem;
        box-sizing: border-box;
    }

    .desc {
        font-size: 1.4rem;
        color: #ddd;
        padding-left: 2rem;
        box-sizing: border-box;
        line-height: 1.6;
    }

    img {
        max-width: 100%;
        height: auto;
        border-radius: 10px;
        object-fit: contain;
    }

    .intro {
        text-align: center;
        font-size: 3rem;
        max-width: 850px;
        margin: auto;
        font-family: Oswald, sans-serif;
        font-weight: 100;
        color: #fff;
    }
}

/* Pagination personnalisée */
.custom-pagination {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #56a7db;
    z-index: 1;
    justify-content: center;
    box-sizing: border-box;
    padding-right: 2rem;
    top: 0;
    right: 0;
    bottom: 0;

    &::before {
        content: "";
        position: absolute;
        left: 4px;
        top: 0;
        bottom: 0;
        width: 1px;
        background-color: #56a7db;
        opacity: 0.5;
        z-index: 0;
    }

    .arrow {
        background: none;
        border: none;
        color: #56a7db;
        font-size: 1.5rem;
        cursor: pointer;
        margin: 1.5rem 3rem 1.5rem 0;
        transition: opacity 0.3s;

        &:disabled {
            opacity: 0.3;
            cursor: default;
        }
    }

    .titles-list {
        list-style: none;
        padding: 0;
        margin: 0;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 1.5rem;

        li {
            position: relative;
            cursor: pointer;
            padding-left: 3rem;
            z-index: 1;

            span {
                user-select: none;
            }

            &.active {
                font-weight: bold;
                color: #fff;

                .dot {
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 8px;
                    height: 8px;
                    background-color: #56a7db;
                    border-radius: 50%;
                    z-index: 2;
                }
            }
        }

        span {
            font-style: italic;
            font-weight: 200;
            font-size: 1.4rem;
        }
    }
}
/* Transition normale */
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: opacity 0.5s ease, transform 0.5s ease;
    width: 100%;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
    opacity: 0;
    transform: translateX(100px);
}

.fade-slide-enter-to,
.fade-slide-leave-from {
    opacity: 1;
    transform: translateX(0);
}

/* Transition avec DÉCALAGE */
.fade-slide-delayed-enter-active,
.fade-slide-delayed-leave-active {
    transition: opacity 0.5s ease 0.1s, transform 0.5s ease 0.1s;
}

.fade-slide-delayed-enter-from,
.fade-slide-delayed-leave-to {
    opacity: 0;
    transform: translateX(100px);
}

.fade-slide-delayed-enter-to,
.fade-slide-delayed-leave-from {
    opacity: 1;
    transform: translateX(0);
}

// Transition image
.fade-img-enter-active,
.fade-img-leave-active {
    transition: opacity 0.5s ease, transform 0.5s ease;
}
.fade-img-enter-from,
.fade-img-leave-to {
    opacity: 0;
}
.fade-img-enter-to,
.fade-img-leave-from {
    opacity: 1;
}

/* Scroll icon */
.scrolldown {
    width: 30px;
    height: 50px;
    border: 3px solid #ff0000;
    border-radius: 25px;
    bottom: 1rem;
    transition: all 0.5s;
    position: absolute;
    margin: auto;

    &.hide {
        opacity: 0;
    }
}
.scrolldown::before {
    content: "";
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    width: 6px;
    height: 6px;
    background-color: #ff0000;
    border-radius: 100%;
    box-shadow: 0px -5px 3px 1px rgba(255, 0, 0, 0.6);
    animation: scrolldown-anim 2s infinite;
}

@keyframes scrolldown-anim {
    0% {
        opacity: 0;
        height: 6px;
    }
    40% {
        opacity: 1;
        height: 10px;
    }
    80% {
        opacity: 0;
        transform: translate(-50%, 20px);
        height: 10px;
    }
    100% {
        opacity: 0;
        height: 3px;
    }
}

.scrolldown::after {
    content: "";
    position: absolute;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    width: 7px;
    height: 7px;
    border: 2px solid #ff0000;
    border-top: none;
    border-left: none;
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% {
        opacity: 0;
    }
    60% {
        opacity: 0.7;
    }
    100% {
        opacity: 0;
    }
}

@media (max-width: 1600px) {
    .fade-slide-enter-from,
    .fade-slide-leave-to {
        opacity: 0;
        transform: translateX(50px);
    }

    .fade-slide-delayed-enter-from,
    .fade-slide-delayed-leave-to {
        opacity: 0;
        transform: translateX(50px);
    }
}

@media (max-width: 1500px) {
    .fade-slide-enter-from,
    .fade-slide-leave-to {
        opacity: 0;
        transform: translateX(20px);
    }

    .fade-slide-delayed-enter-from,
    .fade-slide-delayed-leave-to {
        opacity: 0;
        transform: translateX(20px);
    }
}

@media (max-width: 1200px) {
    .custom-pagination .titles-list li {
        padding-left: 2rem;
    }

    .custom-pagination .titles-list span {
        font-size: 1.2rem;
    }

    .slide-content {
        h1 {
            font-size: 3rem;
        }

        .desc {
            font-size: 1.2rem;
        }

        .intro {
            font-size: 2.6rem;
        }
    }

    swiper-slide {
        padding-right: 13rem;
    }
}

@media (max-width: 992px) {
    .custom-pagination {
        display: none;
    }

    .slide-content {
        h1 {
            font-size: 2.6rem;
        }

        .desc {
            font-size: 1.2rem;
        }

        .intro {
            font-size: 2.4rem;
        }
    }

    swiper-slide {
        padding-right: 0;
    }
}

@media (max-width: 768px) {
    .container-sticky {
        align-items: flex-end;
    }

    .swiper-wrapper-container {
        height: 90vh;
    }

    .slide-content {
        padding: 1rem 1rem;
        text-align: center;

        > div {
            flex-flow: column;

            > div {
                &:first-child {
                    order: 1;
                }
            }
        }

        img {
            max-width: 300px;
            width: 100%;
        }

        h1 {
            font-size: 1.6rem;
            padding: 0;
            margin-bottom: 0;
        }

        .desc {
            font-size: 1rem;
            padding: 0;
        }

        .intro {
            font-size: 2rem;
            padding: 4rem 0 0;
        }
    }
}

@media (max-width: 576px) {
    .slide-content {
        img {
            max-width: 200px;
        }

        .intro {
            font-size: 1.6rem;
        }
    }
}
</style>
